import {
    ACTIONS,
    Action,
    LIMIT_AREA,
    LIMIT_TYPE,
    LimitsConfig,
} from '@main/components/limits-notification/limits-notification.types';
import { INTERVAL_TYPE } from '@main/enums';
import { ICountLimit } from '@shared/interfaces/ITokenPackage';

const VIEWS_IMAGE = 'assets/images/limits-page/report-views-limit.png';

const generateSubscript = (maxCountLimit: ICountLimit) => {
    let subscript = '';
    if (maxCountLimit.MONTHLY && maxCountLimit.DAILY) {
        subscript = `Your current plan allows up to ${maxCountLimit.DAILY} report views/day
        and ${maxCountLimit.MONTHLY} report views/month.`;
    } else if (!maxCountLimit.DAILY) {
        subscript = `Your current plan allows up to ${maxCountLimit.MONTHLY} report views/month.`;
    } else if (maxCountLimit.DAILY) {
        subscript = `Your current plan allows up to ${maxCountLimit.DAILY} report views/day.`;
    }
    return `${subscript}<br>To increase that number, please contact our sales team.`;
};

const askToUpgradeAction: Action = {
    actionId: ACTIONS.ASK_TO_UPGRADE,
    caption: 'Ask to upgrade',
    color: 'accent',
};

export const generatePackageLimitWarningsConfig = (maxCountLimit: ICountLimit): LimitsConfig => {
    const VIEWS_SUBSCRIPT = generateSubscript(maxCountLimit);
    return {
        [LIMIT_TYPE.VIEW]: {
            [LIMIT_AREA.GLOBAL]: {
                [INTERVAL_TYPE.DAILY]: {
                    mailSubject: 'My number of daily reports available has been exceeded',
                    headerImage: VIEWS_IMAGE,
                    title: 'You have reached the daily search limit',
                    subscript: VIEWS_SUBSCRIPT,
                    actions: [askToUpgradeAction],
                },
                [INTERVAL_TYPE.MONTHLY]: {
                    mailSubject: 'My number of monthly reports available has been exceeded',
                    headerImage: VIEWS_IMAGE,
                    title: 'You have reached the monthly search limit',
                    subscript: VIEWS_SUBSCRIPT,
                    actions: [askToUpgradeAction],
                },
            },
        },
    };
};
